// UploadModal.jsx
import React, { useRef, useEffect } from 'react';
import DocumentUpload from './DocumentUpload';
import CloseSVG from '../../assets/Close.jsx';

const UploadModal = ({ isOpen, onClose, onUploadSuccess, formType }) => {
  const modalRef = useRef();

  // Close modal if clicked outside the modal content
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  // console.log("UploadModal", formType);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
        <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-xl font-semibold mb-10">Upload Document</h2>
      
      <div
        ref={modalRef}
        // className="bg-white p-6 rounded-lg max-w-md w-full relative shadow-lg"
      >
      <div className="flex justify-end gap-4">
          <DocumentUpload onUploadSuccess={onUploadSuccess} onClose={onClose} formType={formType}/>
        
        </div>
      </div>
      </div>
    </div>
  );
};

export default UploadModal;
